module.exports = __webpack_public_path__ + "img/g0126.3d83e872.png";